module.exports = "/LikeActive@2x-cefabd3c10d5ab0975400a23333194ac.png";